export const DASHBOARD_ICONS = {
  student: "/images/Person_raising_hand_animated.png",
  attendance: "/images/Bar_chart.png",
  money: "/images/Money_bag.png",
  calendar: "/images/Tear-off_calendar.png",
  fire: "/images/Fire.png",
  check: "/images/Check_mark_button.png",
  muscle: "/images/Flexed_biceps.png",
  phone: "/images/Telephone_Receiver.png",
  warning: "/images/Warning.png",
  party: "/images/Party_popper.png",
  ok: "/images/OK_hand.png",
  siren: "/images/Police_car_light.png",
  memo: "/images/Memo.png",
  pencil: "/images/Pencil.png",
  sun: "/images/Sun.png",
  moon: "/images/Crescent_moon.png",
  sparkles: "/images/Sparkles.png",
  smilingfacewithheart: "/images/Smiling_face_with_hearts.png",
  glowingstar: "/images/Glowing_star.png",
  seedling: "/images/Seedling.png",
  lightbulb: "/images/Light_bulb.png",
  gift: "/images/Wrapped_gift.png",
  hearthands: "/images/Heart_hands.png",
  birthday: "/images/birthday_cake_animated.png",
  weather_sun: "/images/Sun.png",
  weather_cloud_sun: "/images/Sun_behind_small_cloud.png",
  weather_cloud: "/images/Cloud.png",
  weather_rain: "/images/Cloud_with_rain.png",
  weather_snow: "/images/Cloud_with_snow.png",
  weather_lightning: "/images/Cloud_with_lightning_and_rain.png",
  weather_fog: "/images/Fog.png",
  sunwithface: "/images/Sun_with_face.png",
  clock: "/images/Alarm_clock.png",
};

export const DASHBOARD_DEPT_INFO = {
  "청년부": { slogan: "새벽이슬 같은 주의 청년", goals: ["예배의 감격 회복", "소그룹 공동체 활성화", "지역 사회 섬김"] },
  "고등부": { slogan: "세상을 변화시키는 리더", goals: ["매일 큐티 생활화", "친구 전도 축제", "진로 비전 탐색"] },
  "중등부": { slogan: "꿈꾸는 다음 세대", goals: ["성경 통독 1독", "학교 기도 모임", "부모님과 함께하는 예배"] },
  "초등부": { slogan: "예수님을 닮아가는 어린이", goals: ["암송왕 선발대회", "여름 성경 학교", "제자 훈련"] },
  "유치부": { slogan: "말씀 먹고 쑥쑥 자라요", goals: ["예배 태도 바르게", "찬양 율동 배우기", "친구 사랑 실천"] },
};

export const DASHBOARD_SKY_THEMES = {
  morning: {
    gradient: "linear-gradient(to bottom, #87CEEB, #E0F7FA)",
    celestial: { type: "sun", color: "#FFD700", shadow: "0 0 40px #FFD700" },
  },
  day: {
    gradient: 'url("/images/day_sky.jpg")',
    celestial: { type: "sun", color: "#FDB813", shadow: "0 0 60px #FDB813" },
  },
  sunset: {
    gradient: "linear-gradient(to bottom, #FF7E5F, #FEB47B)",
    celestial: { type: "sun", color: "#FF4500", shadow: "0 0 50px #FF4500" },
  },
  night: {
    gradient: 'url("/images/night_sky_v3.png")',
    celestial: { type: "moon", color: "#FEFCD7", shadow: "0 0 60px rgba(255, 255, 200, 0.3)" },
  },
};
